import axiosInstance from "../../../../../../axiosInstance";
import FailModal from "../../../../../../Components/FailModal";

const DeleteWeddingModal = ({ projectId, close, onDeleteSuccess }) => {
  const handleDelete = () => {
    const fullUrl =
      window.localStorage.getItem("BaseURL") +
      "/services/projectmanagement/api/projects/" +
      projectId;

    axiosInstance.delete(fullUrl).then(onDeleteSuccess).catch(console.error);
  };

  return (
    <FailModal
      reverse
      show
      title="Confirm Gallery Deletion"
      description="Are you sure you want to delete this gallery? All your prompts, and settings, will be permanently removed. This action is irreversible. Please confirm to proceed."
      onCancel={close}
      onRetry={handleDelete}
      retryText="Delete"
    />
  );
};

export default DeleteWeddingModal;
